import styled from 'styled-components';

const ArticleLeaderboardItem = styled.article`
  border-bottom: 1px solid #d1d5db;
  display: flex;
  flex-direction: column;
  gap: 4px;
  margin-bottom: 8px;
  padding: 8px 0;
`;

export default ArticleLeaderboardItem;
